import { render } from "./SelectItem.vue?vue&type=template&id=6bbd714f"
import script from "./SelectItem.vue?vue&type=script&lang=js"
export * from "./SelectItem.vue?vue&type=script&lang=js"

import "./SelectItem.vue?vue&type=style&index=0&id=6bbd714f&lang=scss&restr=true"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__